import { render, staticRenderFns } from "./AdminsPage.vue?vue&type=template&id=3d1a9d8b&scoped=true&"
import script from "./AdminsPage.vue?vue&type=script&lang=js&"
export * from "./AdminsPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminsPage.vue?vue&type=style&index=0&id=3d1a9d8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1a9d8b",
  null
  
)

export default component.exports